import { createAction, props } from '@ngrx/store'

export const PullUserRules = createAction('[UserRules] Pull')
export const ReplaceUserRules = createAction('[UserRules] Replace', props<{payload: {rules: string[]}}>())

